import { FormikProps } from "formik";

import { ContactDetailType } from "@/api";
import {
  ContactDetailFormEntry,
  EditClientType,
} from "@/pages/clients/client/components/tabs/master-data-tab/views/personal-data/EditClient.types";

export type ContactDetailsField = "emailContactDetails" | "phoneContactDetails";

export const useContactDetails = (formik: FormikProps<EditClientType>, fieldName: ContactDetailsField) => {
  const entries = formik.values[fieldName];
  const type = fieldName === "emailContactDetails" ? ContactDetailType.Email : ContactDetailType.Phone;

  const remove = (index: number) => {
    const updated = entries.filter((_, i) => i !== index);
    void formik.setFieldValue(fieldName, updated);
  };

  const add = () => {
    const newEntry: ContactDetailFormEntry = { id: null, type, value: "", comment: null };
    void formik.setFieldValue(fieldName, [newEntry, ...entries]);
  };

  return { entries, remove, add };
};
